exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".buyer-order-history .ivu-modal{position:relative;max-width:1000px}", ""]);

// exports
